export enum EditRole {
  OWNER = 'OWNER',
  FAN = 'FAN'
}
